import React, { useEffect, useState, useMemo } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import { useSelector } from 'react-redux'
import Icons from '~/Common-Objects/UI/Icons/index'
import Tab from '~/Common-Objects/Tabs/Tab/Tab'
import Tabs from '~/Common-Objects/Tabs/Tabs'
import i18n from '~/i18n'
import moment from 'moment'

export default function BBTopNavNavigation() {
    const [tabIndex, setTabIndex] = useState(0)
    const history = useHistory()
    const location = useLocation()
    const account = useSelector((state) => state.accountMaster)
    const site = useSelector((state) => state.siteMaster)
    const isMpz = site.siteId == 1

    const progress = account.progress

    const { progressTotal, progressFinished } = useMemo(() => {
        if (!progress) return { progressTotal: 0, progressFinished: 0 }
        let total = 1
        let finished = 1
        for (const key in progress) {
            total++
            if (progress[key]) finished++
        }
        return { progressTotal: total, progressFinished: finished }
    }, [progress])

    const showSetup =
        progress &&
        progressTotal !== progressFinished &&
        isMpz &&
        moment(account.accountMaster.createdAt).isAfter('2025-06-01')

    const subscrberRoutes = [
        {
            label: i18n.t('nav:dropdown.subscribers.all'),
            route: '/cp/subscribers',
            icon: <Icons icon='mainNavAllContacts' style={{ width: 16, height: 16 }} color='#969695' />
        },
        {
            label: i18n.t('nav:dropdown.subscribers.groups'),
            route: '/cp/subscribers/groups',
            icon: <Icons icon='mainNavGroups' style={{ width: 16, height: 16 }} color='#969695' />
        },
        {
            label: i18n.t('nav:dropdown.subscribers.segments'),
            route: '/cp/subscribers/segments',
            icon: <Icons icon='mainNavSegments' style={{ width: 16, height: 16 }} color='#969695' />
        },
        {
            label: i18n.t('nav:dropdown.subscribers.blacklist'),
            route: '/cp/groups/' + account.accountMaster.blackListGroupId,
            icon: <Icons icon='mainNavDenyList' style={{ width: 16, height: 16 }} color='#969695' />
        },
        {
            label: i18n.t('nav:dropdown.subscribers.listCleaning'),
            route: '/cp/subscribers/clean',
            icon: <Icons icon='mainNavListCleaner' style={{ width: 16, height: 16 }} color='#969695' />
        }
    ]

    const campaignRoutes = [
        {
            label: i18n.t('nav:dropdown.campaigns.all'),
            route: '/cp/campaigns',
            icon: <Icons icon='mainNavAllCampaigns' style={{ width: 16, height: 16 }} color='#969695' />
        },
        {
            label: i18n.t('nav:dropdown.campaigns.email'),
            route: '/cp/campaigns?campaignType=1',
            icon: <Icons icon='mainNavEmail' style={{ width: 16, height: 16 }} color='#969695' />
        },
        {
            label: i18n.t('nav:dropdown.campaigns.splitTests'),
            route: '/cp/campaigns?campaignType=10',
            icon: <Icons icon='mainNavAbSplit' style={{ width: 16, height: 16 }} color='#969695' />
        },
        {
            label: i18n.t('nav:dropdown.campaigns.social'),
            route: '/cp/campaigns?campaignType=30',
            icon: <Icons icon='mainNavSocial' style={{ width: 16, height: 16 }} color='#969695' />,
            mpz: true
        },
        {
            label: i18n.t('nav:dropdown.campaigns.sms'),
            route: '/cp/campaigns?campaignType=6',
            action: () => showCampaignCreate(6),
            icon: <Icons icon='mainNavSms' style={{ width: 16, height: 16 }} color='#969695' />,
            mpz: true
        },
        {
            label: i18n.t('nav:dropdown.campaigns.ads'),
            route: account.accountMaster?.beta?.ads ? '/cp/campaigns?campaignType=60' : false,
            action: () => showCampaignCreate(60),
            icon: <Icons icon='mainNavAds' style={{ width: 16, height: 16 }} color='#969695' />,
            mpz: true,
            beta: 'ads'
        },
        {
            divider: true
        },
        {
            label: i18n.t('nav:templates'),
            route: '/cp/templates',
            icon: <Icons icon='mainNavTemplates' style={{ width: 16, height: 16 }} color='#969695' />
        }
    ]

    const websiteRoutes = [
        {
            label: i18n.t('nav:dropdown.websites.forms'),
            route: '/cp/forms',
            icon: <Icons icon='mainNavForms' style={{ width: 16, height: 16 }} color='#969695' />
        },
        {
            label: i18n.t('nav:dropdown.websites.landingpages'),
            route: '/cp/landingpages',
            icon: <Icons icon='mainNavLandingPages' style={{ width: 16, height: 16 }} color='#969695' />
        },
        {
            label: i18n.t('nav:dropdown.websites.tracking'),
            route: '/cp/trackers',
            icon: <Icons icon='mainNavTracking' style={{ width: 16, height: 16 }} color='#969695' />
        }
    ]

    const tabs = [
        {
            label: (
                <>
                    {i18n.t('nav:setup')}{' '}
                    <span
                        className='notification-button-alerts mar-l5'
                        style={{ width: 'fit-content', padding: '0 5px' }}
                    >
                        {progressFinished}/{progressTotal}
                    </span>
                </>
            ),
            route: '/cp/setup',
            permission: undefined,
            show: showSetup
        },
        {
            label: i18n.t('nav:dashboard'),
            route: '/cp/home',
            permission: undefined,
            show: true
        },
        {
            label: i18n.t('nav:subscribers'),
            route: '/cp/subscribers',
            permission: 'subscribers',
            sub: subscrberRoutes,
            show: true
        },
        {
            label: i18n.t('nav:campaigns'),
            route: '/cp/campaigns',
            permission: 'campaigns',
            sub: campaignRoutes,
            show: true
        },
        {
            label: i18n.t('nav:automation'),
            route: '/cp/automation',
            permission: 'automations',
            show: true
        },
        {
            label: i18n.t('nav:websites'),
            route: '/cp/forms',
            permission: 'forms',
            sub: websiteRoutes,
            show: true
        },
        isMpz && {
            label: i18n.t('nav:conversations'),
            route: '/cp/conversations',
            permission: 'conversations',
            show: true,
            isMpz: true
        }
    ].filter(Boolean)

    const setInitialTab = () => {
        const path = location.pathname
        const foundIndex = tabs.findIndex((tab) => path.startsWith(tab.route))
        if (foundIndex !== -1 && tabIndex !== foundIndex) {
            setTabIndex(foundIndex)
        } else if (foundIndex === -1) {
            // custom logic to find the right tab, for example templates or site tracking
            if (path.startsWith('/cp/templates')) {
                setTabIndex(tabs.findIndex((t) => t.route === '/cp/campaigns')) // campaigns
            } else if (
                path.startsWith('/cp/trackers') ||
                path.startsWith('/cp/websites') ||
                path.startsWith('/cp/landingpages')
            ) {
                setTabIndex(tabs.findIndex((t) => t.route === '/cp/forms')) // forms
            } else if (path.startsWith('/cp/groups/')) {
                setTabIndex(tabs.findIndex((t) => t.route === '/cp/subscribers')) // subscribers
            }
        }
    }

    const tabChange = (index, returnUrl) => {
        const tab = tabs[index]
        if (!tab) return
        if (tab.isMpz) {
            if (returnUrl) return '/cp/conversations'
            window.open('/cp/conversations/inbox', '_self')
        } else {
            if (returnUrl) return tab.route
            history.push(tab.route)
        }
        setTabIndex(index)
    }

    useEffect(() => {
        setInitialTab()
    }, [])

    useEffect(() => {
        if (showSetup && location.pathname.startsWith('/cp/home')) {
            history.push(tabs[0].route)
        }
    }, [showSetup])

    useEffect(() => {
        setInitialTab()
    }, [location])

    const capIcon = (
        <svg width='110' height='48' viewBox='0 0 110 42' fill='none' xmlns='http://www.w3.org/2000/svg' class=''>
            <g clipPath='url(#clip0)'>
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M106.701 27.0853C105.798 28.6866 103.993 29.5916 102.048 29.5916C99.3053 29.5916 97.1865 27.8859 96.8046 25.171H109.965C110 24.8226 110 24.3004 110 23.9176C110 18.7657 106.562 15.4937 101.944 15.4937C97.326 15.4937 93.6452 18.7657 93.6452 23.9176C93.6452 29.0695 97.326 32.4458 101.944 32.4458C104.798 32.4458 107.504 31.2229 109.01 28.8373L106.701 27.0853ZM101.944 18.3479C104.549 18.3479 106.493 19.9842 106.875 22.6991H96.8046C97.1865 19.9842 99.2704 18.3479 101.944 18.3479Z'
                    fill='#111111'
                ></path>
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M88.091 32.0979H91.251V7H88.091V32.0979Z'
                    fill='#111111'
                ></path>
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M78.4455 29.6615C82.506 29.6615 82.2047 25.0334 82.2047 25.0334V15.8439H85.3646V25.0334C85.3646 25.0334 85.3712 25.1394 85.3695 25.3251C85.3592 26.6998 85.2186 32.4677 78.5495 32.4677H78.3409C71.6723 32.4677 71.5318 26.6998 71.5214 25.3251C71.5198 25.1394 71.5263 25.0334 71.5263 25.0334V15.8439H74.6863V25.0334C74.6863 25.0334 74.385 29.6615 78.4455 29.6615Z'
                    fill='#111111'
                ></path>
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M62.8819 22.298C60.1769 21.8857 59.1091 21.2827 59.2164 20.1871C59.4016 18.292 61.6675 18.0779 63.1118 18.1866C65.8866 18.3941 66.4712 20.819 66.5006 21.091L69.2241 20.8311C69.0645 19.0954 67.6747 15.7311 63.5569 15.4187C61.3101 15.2494 59.3532 15.7524 58.0445 16.8376C57.0459 17.6661 56.2167 18.9201 56.1197 20.2281C55.8113 24.3756 59.8974 24.9813 62.4363 25.3614C65.661 25.8448 66.414 26.2336 66.3382 27.5051C66.3023 28.1091 65.9906 28.6968 65.5199 29.0813C64.8329 29.6427 63.4654 29.8082 62.1611 29.6689C59.1151 29.3445 58.8481 27.3986 58.8296 27.0315L56.1197 27.0802C56.1486 28.7301 57.2327 31.9464 61.8435 32.4701C64.323 32.7514 66.3557 32.0272 67.3935 31.2752C68.5987 30.4013 69.2557 28.83 69.3347 27.4543C69.5793 23.1861 65.4671 22.6918 62.8819 22.298Z'
                    fill='#111111'
                ></path>
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M46.4335 15.4935C44.1763 15.4935 41.8494 16.5378 40.7734 18.3832V15.842H37.6135V40H40.7734V29.6613C41.8494 31.5412 44.1763 32.4461 46.4335 32.4461C50.8781 32.4461 54.5589 29.1741 54.5589 24.0223C54.5589 18.8704 50.8781 15.4935 46.4335 15.4935ZM46.1208 29.5341C43.5166 29.5341 40.6743 27.6722 40.6743 24.191C40.6743 20.7448 43.3891 18.4761 46.2363 18.4761C49.1532 18.4761 51.5024 20.6809 51.5024 23.9185C51.5024 27.1556 49.0377 29.5341 46.1208 29.5341Z'
                    fill='#111111'
                ></path>
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M28.6349 15.3724C28.5576 15.3724 28.4824 15.3784 28.4056 15.3801C28.4056 15.3801 28.4017 15.3801 28.3996 15.3806V15.3757C28.3996 15.3757 25.7016 15.3844 23.1029 16.439L24.0389 18.9404C24.9547 18.5576 26.4578 18.0944 28.3996 18.0584C28.4786 18.0568 28.5548 18.0524 28.6349 18.0524C32.0907 18.0524 32.1533 21.2463 32.1533 21.2518V22.0792L26.7036 22.0377C26.3516 22.036 24.1397 22.0311 22.6033 23.5156C22.2344 23.8722 21.9413 24.2878 21.7185 24.7488C21.3992 25.4107 21.2298 26.1693 21.2298 27.0017C21.2298 28.0765 21.4978 29.0481 22.0023 29.8766C22.2323 30.2551 22.5074 30.6063 22.837 30.9187C23.8896 31.917 25.3976 32.4725 27.0239 32.4725C27.1568 32.4725 27.2909 32.4692 27.4254 32.4616C29.2925 32.3567 31.0267 31.6183 32.149 29.8007L32.1484 32.0984H34.9591V21.8143C34.9591 19.1687 33.3034 15.3724 28.6349 15.3724ZM27.2685 29.9203C26.2595 29.976 24.0405 29.449 24.0405 27.0017C24.0405 26.3594 24.6442 24.7182 26.6251 24.7182C28.606 24.7182 32.0509 24.7351 32.0509 24.7351C32.0509 27.7466 30.3042 29.7505 27.2685 29.9203Z'
                    fill='#111111'
                ></path>
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M12.1189 29.3132C7.11855 29.3132 3.22912 25.2406 3.22912 20.1581C3.22912 15.0761 7.11855 10.9685 12.1189 10.9685C14.5111 10.9685 16.6158 11.9428 18.2044 13.4469L20.1129 10.8735C18.0464 8.97995 15.2614 7.83575 12.1189 7.83575C5.3479 7.83575 0 13.3355 0 20.1581C0 26.9462 5.3479 32.446 12.1189 32.446C14.8751 32.446 17.3622 31.5634 19.3279 30.0713L18.2818 27.1106C16.6114 28.4296 14.2633 29.3132 12.1189 29.3132Z'
                    fill='#111111'
                ></path>
            </g>
            <defs>
                <clipPath id='clip0'>
                    <rect width='110' height='48' fill='white'></rect>
                </clipPath>
            </defs>
        </svg>
    )

    const tabsComponent = (
        <Tabs value={tabIndex} onChange={tabChange} supportReturnUrl={true}>
            {tabs.map((tab) => {
                return (
                    tab.show && (
                        <Tab key={tab.label} label={tab.label} permission={tab.permission} sub={tab.sub} />
                    )
                )
            })}
        </Tabs>
    )

    if (site.isCapMarketing) {
        return (
            <div className='mob-hide' style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                {capIcon}
                {tabsComponent}
            </div>
        )
    }

    return <div className='mob-hide'>{tabsComponent}</div>
}
